<template>
  <v-card class="default-card" elevation="3">
    <v-card-title>
      {{ $t('components.panelConfiguration.title') }}
    </v-card-title>
    <PanelizationPropositionList :wallTypes="wallTypes" :AllPanelWithCorespondingWall="AllPanelWithCorespondingWall"
      :length="length" :width="width" :isFullPanel="isFullPanel" @selectWallId="selectWallId"
      @handleParentChange="handleParentChange" />
    <v-card-text>
      <TruckDimensions v-model:truckLength="truckLength" v-model:truckWidth="truckWidth"
        v-model:truckHeight="truckHeight" v-model:spacerThickness="spacerThickness" />
      <PanelizationPropositionByType :getTotalPanels="getTotalPanels" :wallTypes="wallTypes"
        :pannelPortions="pannelPortions" :width="width" :length="length" />
      <v-row class="panel-config-row"
        v-if="truckLength && truckWidth && truckHeight && truckLength > 0 && truckWidth > 0 && truckHeight > 0">
        <PanelizationPropositionDisplayByTruck :shipmentTrucks="shipmentTrucks" :isFullPanel="isFullPanel" />
      </v-row>
      <v-row v-else>
        <PanelizationPropositionDisplay :getTotalPanels="getTotalPanels" :wallTypes="wallTypes"
          :pannelPortions="pannelPortions" :width="width" :length="length" />
      </v-row>
    </v-card-text>
    <v-card-actions class="panel-config-actions">
      <v-btn color="secondary" variant="flat" @click="goToPanelCountEstimatorView">
        {{ $t('components.panelConfiguration.backTo') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn color="secondary" variant="flat" @click="saveAndgoToDashboardView">
        {{ $t('buttons.backToDashboardAndSave') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script setup>
import { useRouter } from 'vue-router';
import { computed, ref, watch } from 'vue';
import { useStore } from 'vuex';
import { useDebounceFn } from "@vueuse/core";
import PanelizationPropositionList from '@/components/architect/panelCountEstimator/PanelizationPropositionList.vue'
import TruckDimensions from '@/components/architect/panelCountEstimator/TruckDimensions.vue'
import PanelizationPropositionDisplay from '@/components/architect/panelCountEstimator/PanelizationPropositionPanelDisplay.vue'
import PanelizationPropositionDisplayByTruck from '@/components/architect/panelCountEstimator/PanelizationPropositionPanelDisplayByTruck.vue'
import PanelizationPropositionByType from '@/components/architect/panelCountEstimator/PanelizationPropositionByType.vue'
import { panelizationPropositionCalculation } from '@/composables/panelizationPropositionCalculation';
import { usePanelEstimationResults } from '@/composables/usePanelEstimationResults';

const router = useRouter()
const store  = useStore();

const projectPanelEstimation = computed(() => {
  return store.state.projectData?.panelCountEstimator?.panelEstimation;
});

//TODOEB : this could be better
const truckLength = ref(projectPanelEstimation.value?.truckDimensions?.length ?? 576);
var debouncedTruckLength = ref(projectPanelEstimation.value?.truckDimensions?.length ?? 576);
const truckWidth = ref(projectPanelEstimation.value?.truckDimensions?.width ?? 110);
var debouncedTruckWidth = ref(projectPanelEstimation.value?.truckDimensions?.width ?? 110);
const truckHeight = ref(projectPanelEstimation.value?.truckDimensions?.height ?? 110);
var debouncedTruckHeight = ref(projectPanelEstimation.value?.truckDimensions?.height ?? 110);
const spacerThickness = ref(projectPanelEstimation.value?.spacerThickness ?? 0.25);
var debouncedSpacerThickness = ref(projectPanelEstimation.value?.spacerThickness ?? 0.25);

const thickness = computed(() => {
  if (debouncedSpacerThickness.value) {
    return Number(debouncedSpacerThickness.value) + Number(store.state.maxPanelThickness)
  } else {
    return Number(store.state.maxPanelThickness);
  }
});

const {
  createWallTypes,
  getTwoDigitNumbers,
  handleParentChange,
  groupPanels,
  groupByTruck,
  createPanels,
} = panelizationPropositionCalculation({
  debouncedTruckLength,
  debouncedTruckWidth,
  debouncedTruckHeight,
  thickness,
});
const { getTotalPanels, savePanelEstimationResults } = usePanelEstimationResults();

watch(truckLength, (newVal) => {
  debounceTruckLength(newVal);
})

const debounceTruckLength = useDebounceFn((newVal) => {
  debouncedTruckLength.value = newVal
}, 1000);

watch(truckWidth, (newVal) => {
  debounceTruckWidth(newVal);
})

const debounceTruckWidth = useDebounceFn((newVal) => {
  debouncedTruckWidth.value = newVal
}, 1000);

watch(truckHeight, (newVal) => {
  debounceTruckHeight(newVal);
})

const debounceTruckHeight = useDebounceFn((newVal) => {
  debouncedTruckHeight.value = newVal
}, 1000);

watch(spacerThickness, (newVal) => {
  debounceSpacerThickness(newVal);
})

const debounceSpacerThickness = useDebounceFn((newVal) => {
  debouncedSpacerThickness.value = newVal
}, 1000);

const selectedWallType = computed(() => {
  return store.state.customer.selectedWallType;
});

const length = computed(() => {
  return Number(store.state.projectData?.panelCountEstimator?.panelConfiguration?.maxPanelLength);
});

const width = computed(() => {
  return Number(store.state.projectData?.panelCountEstimator?.panelConfiguration?.maxPanelWidth);
});

const pannelPortions = computed(() => {
  return getTwoDigitNumbers(wallTypes);
});

const shipmentTrucks = computed(() => {
  return groupByTruck(groupPanels(AllPanelWithCorespondingWall.value));
});

const AllPanelWithCorespondingWall = computed(() => {
  return createPanels(wallTypes, pannelPortions, length.value, width.value);
});

const wallTypes = createWallTypes(selectedWallType, length);

function goToPanelCountEstimatorView() {
  router.push({ name: 'PanelCountEstimatorView' })
}

function saveAndgoToDashboardView() {
  savePanelEstimationResults({
    wallTypes,
    pannelPortions,
    shipmentTrucks,
    debouncedTruckLength,
    debouncedTruckWidth,
    debouncedTruckHeight,
    debouncedSpacerThickness,
  });
  router.push({ name: 'ArchitectDashboard' });
}

function isFullPanel(panel) {
  return panel.length === length.value && panel.width === width.value
    || panel.width === length.value && panel.length === width.value;
}

function selectWallId(wallId) {
  store.dispatch("toggleObjectsSelection", { ids: [wallId] });
}

</script>


<style scoped>
@import '@/assets/styles/views/Architect/PanelCountEstimator/PanelConfigurationView.css';
</style>
